export default "__VITE_ASSET__LXdKpYBG__"